var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20123 22.2522C8.71169 22.5839 8.1395 22.773 7.54866 22.7981C6.86054 22.7856 6.20252 22.5136 5.70639 22.0367C5.21025 21.5597 4.91262 20.9129 4.87305 20.2258L7.64702 18.5781L11.9506 20.5061L9.20123 22.2522Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8387 15.1598L8.78278 14.2548C7.86304 13.8515 6.9974 13.5023 6.9974 12.4941C6.98381 12.2976 7.01281 12.1005 7.08242 11.9163C7.15203 11.7321 7.2606 11.5651 7.40072 11.4268L11.7437 13.3351L10.6764 13.9647C10.3763 14.1417 10.1845 14.304 10.1845 14.5352C10.1845 14.7664 10.4649 14.9926 10.8534 15.1598H10.8387Z",
    fill: "#96CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8558 5.67245L10.7458 6.95615C10.5589 7.06927 10.3031 7.24634 10.3031 7.53161C10.3031 7.81687 10.7949 8.0923 11.2229 8.29888L8.59152 7.13813C7.81933 6.79384 7.0373 6.41021 7.0373 5.4708C7.03202 5.12034 7.13509 4.7768 7.33241 4.48712L13.0377 1.00488C13.4371 1.22443 13.7712 1.54575 14.0062 1.93621C14.2411 2.32666 14.3686 2.77236 14.3755 3.22801C14.379 3.73933 14.2383 4.24127 13.9694 4.67624C13.7006 5.11121 13.3146 5.4616 12.8558 5.68721V5.67245Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3361 9.78434L16.8148 10.0844L12.4521 8.16127L17.5181 5.10693C17.9186 5.32772 18.2542 5.64963 18.4916 6.04056C18.7289 6.43148 18.8596 6.87778 18.8707 7.33497C18.8788 7.8491 18.7383 8.35465 18.4661 8.79089C18.1939 9.22712 17.8015 9.57549 17.3361 9.79417V9.78434Z",
    fill: "#96CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6526 13.4927L16.2347 14.6239C17.2184 15.0567 17.4988 15.5682 17.4988 16.2076C17.4903 16.3969 17.4421 16.5823 17.3574 16.7517C17.2726 16.9212 17.1532 17.0709 17.0069 17.1913L12.6738 15.2633L13.4018 14.86C14.0215 14.5108 14.233 14.3091 14.233 14.0829C14.233 13.8566 14.0805 13.6943 13.6575 13.4976L13.6526 13.4927Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2611 22.9998C17.1136 22.1724 15.872 21.484 14.5625 20.9488L8.00134 18.0322C6.34875 17.2944 5.25195 16.3206 5.25195 14.668C5.25195 13.0154 6.02906 12.2875 7.03733 11.6481L7.40129 11.4268C7.26118 11.5651 7.1526 11.7321 7.08299 11.9163C7.01339 12.1005 6.98438 12.2976 6.99798 12.4941C6.99798 13.5023 7.86362 13.8515 8.78336 14.2548L16.4167 17.619C17.7545 18.1945 18.9645 19.1782 18.9645 20.8406C18.9809 21.6191 18.733 22.3803 18.2611 22.9998Z",
    fill: "#4C9847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.474 16.8867L16.9821 17.1867C17.1284 17.0663 17.2478 16.9165 17.3325 16.7471C17.4173 16.5776 17.4654 16.3923 17.474 16.203C17.474 15.5636 17.1739 15.0521 16.2099 14.6193L8.04538 11.0338C6.3928 10.2911 5.36487 9.35168 5.36487 7.70893C5.35946 7.04359 5.53803 6.3897 5.88087 5.81946C6.22371 5.24922 6.71746 4.78482 7.30762 4.47754C7.1103 4.76722 7.00724 5.11076 7.01252 5.46122C7.01252 6.40063 7.79454 6.78428 8.56673 7.12856L16.5001 10.6305C17.951 11.2748 19.1216 12.2486 19.1216 13.9996C19.1384 14.5873 18.9908 15.168 18.6953 15.6764C18.3999 16.1847 17.9683 16.6005 17.4494 16.8768L17.474 16.8867Z",
    fill: "#296085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.283,
    height: 22,
    fill: "white",
    transform: "translate(4.8584 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc24);
export default __webpack_public_path__ + "static/media/SC제일-24.cb4f3bcf643f5899544275230b256524.svg";
export { ForwardRef as ReactComponent };